module.exports = __webpack_public_path__ + "img/camera_reginato.b2331952.jpg";